import React from 'react';
import { Skeleton } from '@mui/material';
import { MuiCard } from '@ace/ace-ui-web';
import styles from './SkeletonCards.module.css';

interface SkeletonCardsProps {
  /**
   * Number of skeleton cards to render
   * @default 4
   */
  count?: number;
  /**
   * Width of each card
   * @default 176
   */
  cardWidth?: number;
  /**
   * Height of each card
   * @default 207
   */
  cardHeight?: number;
  /**
   * Size of the circular skeleton (gauge area)
   * @default 140
   */
  gaugeSize?: number;
}

/**
 * SkeletonCards Component - Displays loading skeleton cards
 * Used while waiting for data to load in card-based layouts
 */
const SkeletonCards: React.FC<SkeletonCardsProps> = ({
  count = 4,
  cardWidth = 176,
  cardHeight = 207,
  gaugeSize = 140,
}) => {
  return (
    <div className={styles.container}>
      {[...Array(count)].map((_, index) => (
        <div
          key={`skeleton-${index}`}
          className={styles.skeletonCard}>
          <MuiCard
            borderRadius={2}
            elevation={1}
            height={cardHeight}
            padding={2}
            variant="elevation"
            width={cardWidth}>
            <div className={styles.cardContent}>
              {/* Skeleton Title */}
              <Skeleton
                variant="text"
                width={80}
                height={24}
                sx={{ marginBottom: '10px' }}
              />

              {/* Skeleton Gauge Area */}
              <div className={styles.gaugeArea}>
                <Skeleton
                  variant="circular"
                  width={gaugeSize}
                  height={gaugeSize}
                />
                <Skeleton
                  variant="text"
                  width={40}
                  height={18}
                />
              </div>
            </div>
          </MuiCard>
        </div>
      ))}
    </div>
  );
};

export default SkeletonCards;
